var map = {
	"./caltech.png": 623,
	"./caltech@2x.png": 624,
	"./campridge.png": 625,
	"./campridge@2x.png": 626,
	"./harvard.png": 627,
	"./harvard@2x.png": 628,
	"./mit.png": 629,
	"./mit@2x.png": 630,
	"./oxford.png": 631,
	"./oxford@2x.png": 632,
	"./stanford.png": 633,
	"./stanford@2x.png": 634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;